import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import { QuoteOrderLogModelType } from '@teinor/erp/types/company/order/quote/quoteOrder/quoteOrderLog'
import OrderStatusBar from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar'
import { displayDate } from '../../../../../../../../utils/globals/date'
import { Fragment } from 'react'
import { getOrderStatusBarType } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBar/functions'
import OrderStatusBarDropDown from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderStatusBarDropDown'
import { BuyOrderStatusInversed } from '@teinor/erp/types/company/order/buy/buyOrder'
import { faClock, faPenCircle } from '@fortawesome/pro-light-svg-icons'
import { faCheckCircle, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons'

interface BuyOrderStatusBarProps extends CreateStatusBarProps {}

const BuyOrderStatusBar: React.FC<BuyOrderStatusBarProps> = ({ orderStatus, OrderLogs }) => {
    const { statuses } = useCreateStatusBar({ orderStatus, OrderLogs })
    
    return (
        <OrderStatusBar statuses={statuses} currentOrderStatus={orderStatus} getOrderStatusBarType={getOrderStatusBarType}/>
    )
}

export interface CreateStatusBarProps {
    orderStatus: number
    OrderLogs: QuoteOrderLogModelType[]
}

const useCreateStatusBar = ({ orderStatus, OrderLogs, }: CreateStatusBarProps) => {
    const { t } = useTwinTranslation()
    let statuses: TwinDictionary[] = []
    const dictOrderLogs: TwinDictionary = {}
    for (const log of OrderLogs) {
        if (!dictOrderLogs[log.logType]) {
            dictOrderLogs[log.logType] = [log]
        } else {
            dictOrderLogs[log.logType] = [...dictOrderLogs[log.logType], log]
        }
    }
    statuses.push({
        id: 0,
        name: t('draft', 'Borrador'),
        logType: 0,
        color: 'bg-gray-33',
        icon: faPenCircle,
        className: 'text-gray-33',
        extraClassName: 'border border-gray-33',
        renderMessage: dictOrderLogs[0]?.length ? <RenderLogMessage logs={dictOrderLogs[0] || []} /> : null
    })
    statuses.push(
        {
            id: 1,
            name: t('pendingReceive', 'Pendiente de recibir'),
            logType: 2,
            color: 'bg-orange-DE',
            icon: faClock,
            className: 'text-orange-DE',
            extraClassName: 'border border-orange-DE',
            renderMessage: dictOrderLogs[2]?.length ? <RenderLogMessage logs={dictOrderLogs[2] || []} /> : null
        }
    )
    if (orderStatus === 3) {
        statuses.push({
            id: 3,
            name: t('deniedP', 'Cancelado'),
            logType: 4,
            color: 'bg-red-BA',
            icon: faXmarkCircle,
            className: 'text-red-BA',
            renderMessage: dictOrderLogs[4]?.length ? <RenderLogMessage logs={dictOrderLogs[4] || []} /> : null
        })
    } else {
        statuses.push({
            id: 2,
            name: t('received', 'Recibido'),
            logType: 3,
            color: 'bg-green-43',
            icon: faCheckCircle,
            className: 'text-green-43',
            renderMessage: dictOrderLogs[3]?.length ? <RenderLogMessage logs={dictOrderLogs[3] || []} /> : null
        })
    }
    return { statuses }
}

interface RenderLogMessageProps {
    logs: QuoteOrderLogModelType[]
}

const RenderLogMessage: React.FC<RenderLogMessageProps> = ({ logs }) => {
    const { tVars } = useTwinTranslation()
    const renderMessage: JSX.Element[] = []
    for (const log of logs) {
        const options = { employeeTrigger: log.EmployeeTrigger?.fullname_short || '', date: displayDate(new Date(log.createdAt)), 'interpolation': { 'escapeValue': false }, }
        const dictOrderLogsMessages: TwinDictionary = {
            0: tVars('createdBuyOrderLogMessage', '{{employeeTrigger}} creó el pedido el {{date}}', options),
            1: '',
            2: tVars('buyWaitingResponseOrderLogMessage', '{{employeeTrigger}} marcó el pedido como esperando respuesta el {{date}}', options),
            3: tVars('acceptedBuyOrderLogMessage', '{{employeeTrigger}} marcó el pedido como aceptado el {{date}}', options),
            4: tVars('deniedBuyOrderLogMessage', '{{employeeTrigger}} marcó el pedido como denegado el {{date}}', options),
        }
        if (dictOrderLogsMessages[log.logType]) {
            renderMessage.push(<div className='my-5' key={log.id} > {dictOrderLogsMessages[log.logType]} </div>)
        }
    }
    if (!renderMessage.length) {
        return null
    }
    return (<Fragment>{renderMessage}</Fragment>)
}

export const BuyOrderStatusBarNew: React.FC<BuyOrderStatusBarProps> = ({ orderStatus, OrderLogs }) => {
    const { statuses } = useCreateStatusBar({ orderStatus, OrderLogs })

    return (
        <OrderStatusBarDropDown statuses={statuses} currentOrderStatus={orderStatus} getOrderStatusBarType={getOrderStatusBarType} isAccepted={orderStatus === BuyOrderStatusInversed['accepted']} />
    )
}

export default BuyOrderStatusBar